import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { FileUp, Loader2, Trash2, FileCheck2 } from "lucide-react";
import { api, uploadEbook } from "../../lib/api";

const opts = { withCredentials: true };
const mb = (n) => `${(n / 1024 / 1024).toFixed(1)} Mo`;

export const EbookUploadField = ({ extractId }) => {
  const input = useRef(null);
  const [master, setMaster] = useState(null);
  const [progress, setProgress] = useState(null);
  useEffect(() => {
    if (extractId) api.get("/admin/ebooks", opts).then((r) => setMaster(r.data.find((m) => m.extract_id === extractId) || null)).catch(() => {});
  }, [extractId]);

  if (!extractId) return <p data-testid="ebook-save-first" className="text-xs font-body text-[#757575]">Enregistrez d'abord l'extrait, puis rouvrez-le pour déposer le fichier du livre complet.</p>;

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setProgress(0);
    try {
      setMaster(await uploadEbook(extractId, file, setProgress));
      toast.success("Fichier du livre déposé");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Échec du dépôt");
    } finally { setProgress(null); }
  };
  const remove = async () => {
    if (!window.confirm("Retirer le fichier du livre complet ? Les ventes déjà livrées restent accessibles.")) return;
    await api.delete(`/admin/ebooks/${extractId}`, opts).then(() => setMaster(null)).catch(() => toast.error("Suppression impossible"));
  };

  return (
    <div data-testid="ebook-upload-field" className="space-y-3">
      {master ? (
        <p data-testid="ebook-master-info" className="flex flex-wrap items-center gap-2 text-sm font-body text-[#1A1A1A]">
          <FileCheck2 size={16} className="text-[#2C402E]" /> {master.filename} · {master.format.toUpperCase()} · {mb(master.size)}{master.pages ? ` · ${master.pages} pages` : ""}
          <button type="button" onClick={remove} data-testid="ebook-master-delete" className="text-[#9E4735] ml-2"><Trash2 size={14} /></button>
        </p>
      ) : <p className="text-xs font-body text-[#757575]" data-testid="ebook-master-none">Aucun fichier déposé.</p>}
      <button type="button" onClick={() => input.current?.click()} disabled={progress !== null} data-testid="ebook-upload-button" className="flex items-center gap-2 border border-[#2C402E] text-[#2C402E] hover:bg-[#2C402E] hover:text-[#FAF9F6] px-4 py-2 text-xs font-body transition-colors disabled:opacity-60">
        {progress !== null ? <><Loader2 size={13} className="animate-spin" /> Dépôt… {progress} %</> : <><FileUp size={13} /> {master ? "Remplacer le fichier" : "Déposer le PDF ou l'EPUB"}</>}
      </button>
      <input ref={input} type="file" accept=".pdf,.epub,application/pdf,application/epub+zip" onChange={onFile} className="hidden" data-testid="ebook-upload-input" />
      <p className="text-[11px] font-body text-[#757575]">Fichier d'origine, gardé dans un espace privé (150 Mo max). Chaque acheteur reçoit une copie marquée à son nom.</p>
    </div>
  );
};
